import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { AuthService } from 'src/app/auth.service';
/* eslint-disable */

@Directive({ selector: '[nioCanAccess]', standalone: true })
export class CanAccessDirective implements OnInit {
  @Input('nioCanAccess') canAccess: string[];
  disable = false;
  hide = false;

  @Input() set disableAccess(disableAccess: boolean) {
    this.disable = disableAccess;
    this.eanbleDisableAccess();
  }

  @Input('hideActionOnNoAccess') set hideAction(hideAction: boolean) {
    this.hide = hideAction;
    this.eanbleDisableAccess();
  }

  constructor(
    private render: Renderer2,
    private el: ElementRef,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.eanbleDisableAccess();
  }

  eanbleDisableAccess() {
    const claims = this.authService.getClaims();
    if (!this.validateUser(claims, this.canAccess) || this.disable) {
      this.render.setAttribute(this.el.nativeElement, 'disabled', 'true');
      this.render.addClass(this.el.nativeElement, 'disabled');
      this.el.nativeElement.removeAllListeners('click');
      this.el.nativeElement.removeAllListeners('dbclick');
      if (this.hide) {
        // this.render.addClass(this.el.nativeElement, 'hidden');
        this.el.nativeElement.style.display = 'none';
      }
    }
  }

  validateUser(claims, roles: string[]): boolean {
    let isValidUser = false;
    if (
      claims?.role instanceof Array &&
      claims.role?.length > 0 &&
      roles &&
      roles.length > 0
    ) {
      isValidUser =
        roles.findIndex((roleRequired) =>
          claims.role.find((actualRole) => roleRequired === actualRole)
        ) > -1;
    } else if (roles && roles.length > 0) {
      isValidUser = roles.indexOf(claims?.role) > -1;
    }
    return isValidUser;
    // if (claims?.role instanceof Array && claims.role?.length > 0) {
    //   isValidUser = AppConstant.Roles.findIndex(roleRequired =>
    //     claims.role.find(actualRole => roleRequired === actualRole)) > -1 ;
    // }
    // return AppConstant.UserRole.ADMIN === claims.role;
  }
}
